module.exports = __webpack_public_path__ + "static/img/touxaing.0e1fbce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/touxaing.jpg
// module id = +X15
// module chunks = 23